<div
  id="product-carousel"
  class="carousel"
  [ngClass]="{
    'carousel--modal': theme === 'modal'
  }"
>
  <ul
    id="product-carousel-list"
    class="carousel__list"
    [ngClass]="{
      'carousel__list--landpage': theme === 'landpage',
      'carousel__list--modal': theme === 'modal'
    }"
  >
    <div
      id="product-carousel-action-group"
      class="carousel__action-group"
      [ngClass]="{
        'carousel__action-group--modal': theme === 'modal'
      }"
    >
      <button
        id="product-carousel-button-prev"
        class="carousel__button carousel__button--prev"
        (click)="click(-1)"
        [disabled]="disabledPrevious()"
      >
        <span nz-icon nzType="left" nzTheme="outline"></span>
      </button>
      <button
        id="product-carousel-button-next"
        class="carousel__button carousel__button--next"
        (click)="click(1)"
        [disabled]="disabledNext()"
      >
        <span nz-icon nzType="right" nzTheme="outline"></span>
      </button>
    </div>
    <li
      id="product-carousel-item-prev"
      class="carousel__list-item carousel__list-item--prev"
      [innerHtml]="itemPrevious"
    ></li>
    <li
      id="product-carousel-item-current"
      [style.touch-action]="'pan-y'"
      (swiperight)="click(-1)"
      (swipeleft)="click(1)"
      [ngClass]="{
        'carousel__list-item': true,
        'carousel__list-item--current': true,
        'carousel__list-item--iPad': isIpad()
      }"
      [innerHtml]="itemActual"
      (click)="clickImgCurrent()"
      [ngStyle]="{ width: listCarousel.length > 0 ? '100%' : 'inherit' }"
    ></li>
    <li
      id="product-carousel-item-next"
      class="carousel__list-item carousel__list-item--next"
      [innerHtml]="itemNext"
    ></li>
  </ul>
  <div class="product-carousel-paginator" *ngIf="listCarousel?.length">
    {{ index + 1 }}/{{ listCarousel?.length }}
  </div>
  <app-thumbnail [listThumbnail]="listCarousel" [indexSelected]="index" [type]="typeHtml" (sendIndex)="receiveIndex($event)"
  *ngIf="thumbnail"></app-thumbnail>
</div>
